import toNumber from 'lodash/toNumber'
import NumberFormat from 'react-number-format'

const CurrencyFormatter = props => {
  const isFrench = props.locale === 'fr'
  const value = toNumber(props.value)
  const prefix = isFrench ? undefined : '$'
  const suffix = isFrench ? '\u00a0$' : undefined
  const decimal = isFrench ? ',' : '.'
  if (isNaN(value) && props.fallback) {
    const sep = props.fallback.replace(/\./g, decimal)
    const returnValue = [prefix, sep, suffix].filter(v => !!v).join('')
    return <>{returnValue}</>
  }
  return (
    <>
      {props.isDeduction && <span>{'('}</span>}
      <NumberFormat
        value={value}
        displayType="text"
        thousandSeparator={isFrench ? '\u00a0' : ','}
        decimalSeparator={decimal}
        prefix={prefix}
        suffix={`${suffix || ''}${props.suffix || ''}`}
        decimalScale={2}
        fixedDecimalScale={props.fixedDecimalScale}
      />
      {props.isDeduction && <span>{')'}</span>}
    </>
  )
}

export default CurrencyFormatter
